export default __webpack_public_path__ + "static/media/Tomato.26f6f72d.jpg";